const notificationsActions = {
	NOTIFICATIONS_READ_SET: 'NOTIFICATIONS_READ_SET',
	pushReadNotifications: (readNotifications) => ({
		type: notificationsActions.NOTIFICATIONS_READ_SET,
		readNotifications,
	}),
	NOTIFICATIONS_SHOW_MORE: 'NOTIFICATIONS_SHOW_MORE',
	showMore: () => ({ type: notificationsActions.NOTIFICATIONS_SHOW_MORE }),
	NOTIFICATION_REINIT: 'NOTIFICATION_REINIT',
	reinit: () => ({ type: notificationsActions.NOTIFICATION_REINIT }),
};

export default notificationsActions;
